import React, { useState, useEffect, useRef } from 'react';
import {MapContainer, TileLayer, Marker, Popup, ZoomControl, Polyline, FeatureGroup, Polygon} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'; // CSS di Leaflet
import 'leaflet-draw/dist/leaflet.draw.css'; // CSS di Leaflet Draw
import FlyObject from "./comp/FlyObject";
import FlyObjectDrone from './comp/FlyObjectDrone';
import FlyObjectBarca from './comp/FlyObjectBarca';
import InfoBox from "./comp/InfoBox";
import directionFunction from './lib/directionFunction';
import ControlPanel from "./comp/ControlPanel";
import AuthController from './comp/AuthController';
import axios from 'axios';
import { LayerGroup, LayersControl } from "react-leaflet";
import ControlPanelResponsive from './comp/ControlPanelResponsive';
import AuthControllerWindy from './comp/AuthControllerWindy';
import ControlPanelWindy from './comp/ControlPanelWindy';
import InfoBoxWindy from './comp/InfoBoxWindy';
import InfoBoxResponsiveIos from './comp/InfoBoxResponsiveIos';
import InfoBoxResponsiveNoIos from './comp/InfoBoxResponsiveNoIos';
import UserObject from './comp/UserObject';
import Map3DComponent from './comp/Map3DComponent';


function App(props) {

    const isMob = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const [heading3D , setHeading] = useState(0);

    const [startIndex, setStartIndex] = useState(0);

    const _logga = (...any) => {
        // console.log("[htk][app]", ...any);
    }

    const flyZoomOptions = {
        animate: true, duration: 0.5
    }

    const [buttonStates, setButtonStates] = useState({});

    const [mappaWindy, setMappaWindy] = useState(null);

    const queryParams = new URLSearchParams(window.location.search)
    const codeStart = queryParams.get("code")
    _logga("codeStart", codeStart)
    const [startPosition, setStartPosition] = useState( props.startPosition);
    const [listSns, setListSns] = useState(props.sns);
    const [snsLive, setSnsLive] = useState([]);
    const [serialsAttivi, setSerialsAttivi] = useState([]);
    const [FlyObjects, setFlyObjects] = useState([]);
    const [zoomLevelBase, setZoomLevelBase] = useState(7);
    const [snsJson, setSnsJson] = useState(props.snsJson);
    const [timePolling, setTimePolling] = useState(props.timePolling);
    const [code, setCode] = useState("1234");
    const [dataCode, setDaCode] = useState(null);
    const [userTipo, setUserTipo] = useState(0);
    const userTipoRef = useRef(userTipo); // Crea un ref per tenere sempre aggiornato il valore
    const apiClient = axios.create({
        baseURL: props.htkBackend,
        withCredentials: true,
    })

    const [mappa, setMap] = useState(null);

    const breakpointRules = getBreakpointRules(window.innerWidth);

    const breakpointRulesResponsive = getBreakpointRulesResponsive(window.innerWidth);

    // stati bottoni infobox
    const [infoboxStates, setInfoboxStates] = useState({});
    const [infoboxStatesPhoto, setInfoboxStatesPhoto] = useState({});
    const [infoboxStatesPolygon, setInfoboxStatesPolygon] = useState({});
    const [infoboxStatesStreaming, setInfoboxStatesStreaming] = useState({});

    // stati bottoni infobox windy
    const [infoboxStatesWindy, setInfoboxStatesWindy] = useState({});
    const [infoboxStatesWindySimu, setInfoboxStatesWindySimu] = useState({});

    const [infoboxStatesSimu, setInfoboxStatesSimu] = useState({});
    const [infoboxStatesPhotoWindy, setInfoboxStatesPhotoWindy] = useState({});
    const [infoboxStatesStreamingWindy, setInfoboxStatesStreamingWindy] = useState({});

    const [sessioniFromChild, setSessioniFromChild] = useState([]);

    const [currentIconTypeStates, setCurrentIconTypeStates] = useState({});

    const handleIconTypeChange = (serialNumber, iconType) => {
        setCurrentIconTypeStates(prevStates => ({
            ...prevStates,
            [serialNumber]: iconType
        }));
    };

    // Aggiorna il ref ogni volta che userTipo cambia
    useEffect(() => {
        userTipoRef.current = userTipo;
    }, [userTipo]);
    
    useEffect(() => {

        //creazioneMappa();

        setTimeout(function() {
            //creazioneMappa2();
        }, 1500);
        
    }, []);


    // Funzione di callback per ricevere il valore aggiornato di sessioni dal componente figlio
    const handleSessioniChange = (newSessioni) => {
        setSessioniFromChild(newSessioni);
    };


    const fetchSerialAuth = async() => {
        
        apiClient.get("/datalive/listSns")
            .then((response) => {
                if (response.status == 200) {
                    let lstSNS = [];
                    if ( typeof response.data.serials == "undefined") {
                        lstSNS = [];
                    } else {
                        lstSNS = response.data.serials;
                    }

                    setListSns(lstSNS);
                }
            })
    }

    
    const fetchSerials = async(...listSns) => {
        const fetchSerial = async(sns) => {
                let baseUrl = props.htkCDN + "/" + sns.sn + "/history.json?"+Math.random();
                const url = new URL(baseUrl);
                //const chkHistory = checkHistory(url.href);
                //console.log("chkHistory:",chkHistory);
      //          if ( chkHistory) {

                    const res = await fetch(url.href);
                    const data = await res.json();


                    //console.log("RES: ", res);

                    let  newDataWithDirection = [];
                    if ( data.points.length >= 1) {
                        newDataWithDirection = data.points.map((p, i, a) => {
                            if ( i > 0) {
                                let p1 = {lat: a[i-1].point.points.LATITUDE, lng:a[i-1].point.points.LONGITUDE };
                                let p2 = {lat: p.point.points.LATITUDE, lng:p.point.points.LONGITUDE };

                                return {
                                    ...p,
                                    Direction: directionFunction(p1, p2),
                                    SN: sns.sn,
                                    ALIAS : sns.alias
                                }
                            } else {
                                return {...p,
                                    Direction: 0,
                                    SN: sns.sn,
                                    ALIAS : sns.alias}
                            }
                        })
                    }
                    const {dataSns: dataListSns} = newDataWithDirection
                    return newDataWithDirection;
            /*    } else {
                    console.log("NOT EXIST");
                }
            
            */
        };

        try {
            const promises = [];

            let elencoSerialiAutorizzati = listSns.filter(e => {
                return serialsAttivi.some(item => item.sn ===e.sn);
            });

            elencoSerialiAutorizzati.push()

            elencoSerialiAutorizzati.map( (singleSns) => {
                promises.push(fetchSerial(singleSns));
            });

            const snsLists = await Promise.all(promises);

            setFlyObjects(snsLists);

        } catch (err) {
            console.log("Errore:", err);
        }

    };

    const setFlyObject = (FO, stateButton, alias) => {
        setSnsLive(prevList => {
            const newList = stateButton 
                ? prevList.filter(value => value !== FO)
                : [...new Set([...prevList, FO])]; // Usiamo Set per evitare duplicati
                
            // Aggiorniamo gli stati dei bottoni
            if (stateButton) {
                toggleFollowTrue(alias, stateButton);
                togglePhotoTrue(alias, stateButton);
                togglePolygonTrue(alias, stateButton);
            } else {
                toggleFollowFalse(alias, stateButton);
                togglePhotoFalse(alias, stateButton);
                togglePolygonFalse(alias, stateButton);
                toggleStreamingFalse(alias, stateButton);
            }
            
            return newList;
        });
    };
    

    const listaSnsAttivi = (serialsAttivi) => {
        setSerialsAttivi(serialsAttivi);
    }

    const _userTipo = (tipo) => {
        setUserTipo(tipo);
    }

    useEffect( () => {
        setTimePolling(1000);
    }, [snsLive])

    useEffect(() => {
        const intervalAuth = setInterval(() => {
            fetchSerialAuth();
        }, 2000);

        const intervalSerials = setInterval(() => {
            fetchSerials(...snsLive);
        }, timePolling);

        return () => {
            clearInterval(intervalAuth);
            clearInterval(intervalSerials);
        };
    }, [timePolling, snsLive]);


    const onLoginToggle = (newState) => {
        _logga("Login status changed to:", newState)
    }

    function _checkAccess() {
        setCode("1234");
        props.accessMode = true;
    }

    useEffect(() => {
        if (!props.accessMode && codeStart) {
            _checkAccess();
        }
    })

// questo effetto si assicura che lo stato infoboxStates sia aggiornato in modo che ogni alias presente in listSns abbia un corrispondente valore booleano in infoboxStates, impostato su false se non esiste ancora
      
// effetti bottoni infobox
    useEffect(() => {    
          const updatedStates = { ...infoboxStates };
          listSns.forEach((sn) => {
            if (!(sn.alias in updatedStates)) {
              updatedStates[sn?.alias] = false; 
            }
          });
          setInfoboxStates(updatedStates);
      }, [listSns]);

      useEffect(() => {    
          const updatedStates = { ...infoboxStatesSimu };
          listSns.forEach((sn) => {
            if (!(sn.alias in updatedStates)) {
              updatedStates[sn?.alias] = false; 
            }
          });
          setInfoboxStatesSimu(updatedStates);
      }, [listSns]);

      useEffect(() => {
        const updatedStates = { ...infoboxStatesPhoto };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesPhoto(updatedStates);
    }, [listSns]);

    useEffect(() => {
        const updatedStates = { ...infoboxStatesPolygon };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesPolygon(updatedStates);
    }, [listSns]);

    useEffect(() => {
        const updatedStates = { ...infoboxStatesStreaming };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesStreaming(updatedStates);

        //console.log("Infobox States Streaming " + JSON.stringify(infoboxStatesStreaming));

    }, [listSns]);

    //console.log("Infobox States Streaming " + JSON.stringify(infoboxStatesStreaming));

// effetti bottoni infobox windy
    useEffect(() => {    
        const updatedStates = { ...infoboxStatesWindy };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesWindy(updatedStates);
    }, [listSns]);

    useEffect(() => {    
        const updatedStates = { ...infoboxStatesWindySimu };
        listSns.forEach((sn) => {
          if (!(sn.alias in updatedStates)) {
            updatedStates[sn?.alias] = false; 
          }
        });
        setInfoboxStatesWindySimu(updatedStates);
    }, [listSns]);

    useEffect(() => {
      const updatedStates = { ...infoboxStatesPhotoWindy };
      listSns.forEach((sn) => {
        if (!(sn.alias in updatedStates)) {
          updatedStates[sn?.alias] = false; 
        }
      });
      setInfoboxStatesPhotoWindy(updatedStates);
  }, [listSns]);

  useEffect(() => {
      const updatedStates = { ...infoboxStatesStreamingWindy };
      listSns.forEach((sn) => {
        if (!(sn.alias in updatedStates)) {
          updatedStates[sn?.alias] = false; 
        }
      });
      setInfoboxStatesStreamingWindy(updatedStates);
  }, [listSns]);


    const changeClick = () => {
        if(mappa){ 
            if(mappa.dragging){
                mappa.dragging.disable();
            }
            if(mappa.scrollWheelZoom){
                mappa.scrollWheelZoom.disable();
            }
        }
    }
    
    const changeClick2 = () => {
        if(mappa){
            if(mappa.dragging){
                mappa.dragging.enable();
            }
            if(mappa.scrollWheelZoom){
                mappa.scrollWheelZoom.enable();
            }
        }
    }

    // GESTIONE CLICK BOTTONI INFOBOX

    const toggleFollow = (nomeSeriale) => {
        setInfoboxStates((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const togglePhoto = (nomeSeriale) => {
        setInfoboxStatesPhoto((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const togglePolygon = (nomeSeriale) => {
        setInfoboxStatesPolygon((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const toggleStreaming = (nomeSeriale) => {
        setInfoboxStatesStreaming((prevState) => ({
          ...prevState,
          [nomeSeriale]: !prevState[nomeSeriale],
        }));
      };

      const toggleFollowTrue = (nomeSeriale, stateButton) => {
        if (infoboxStates[nomeSeriale]) {
            setInfoboxStates((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const togglePhotoTrue = (nomeSeriale, stateButton) => {
        if (infoboxStatesPhoto[nomeSeriale]) {
            setInfoboxStatesPhoto((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const togglePolygonTrue = (nomeSeriale, stateButton) => {
        if (infoboxStatesPolygon[nomeSeriale]) {
            setInfoboxStatesPolygon((prevState) => ({
            ...prevState,
            [nomeSeriale]: true,
            }));
        }
      };

      const toggleFollowFalse = (nomeSeriale, stateButton) => {
        setInfoboxStates((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const togglePhotoFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesPhoto((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const togglePolygonFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesPolygon((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

      const toggleStreamingFalse = (nomeSeriale, stateButton) => {
        setInfoboxStatesStreaming((prevState) => ({
          ...prevState,
          [nomeSeriale]: false,
        }));
      };

// GESTIONE CLICK BOTTONI INFOBOX WINDY

  const toggleFollowWindy = (nomeSeriale) => {
    setInfoboxStatesWindy((prevState) => {
      const newState = {
        ...prevState,
        [nomeSeriale]: !prevState[nomeSeriale],
      };
      // Disattiva tutti gli altri quando questo viene attivato
      if (newState[nomeSeriale]) {
        Object.keys(newState).forEach((key) => {
          if (key !== nomeSeriale) {
            newState[key] = false;
          }
        });
        // Disattiva anche l'altro stato (Simu) per questo seriale
        setInfoboxStatesWindySimu((prevSimuState) => ({
          ...prevSimuState,
          [nomeSeriale]: false,
        }));
      }
      return newState;
    });
  };
  
  const toggleFollowWindySimu = (nomeSeriale) => {
    setInfoboxStatesWindySimu((prevState) => {
      const newState = {
        ...prevState,
        [nomeSeriale]: !prevState[nomeSeriale],
      };
      // Disattiva tutti gli altri quando questo viene attivato
      if (newState[nomeSeriale]) {
        Object.keys(newState).forEach((key) => {
          if (key !== nomeSeriale) {
            newState[key] = false;
          }
        });
        // Disattiva anche l'altro stato (non Simu) per questo seriale
        setInfoboxStatesWindy((prevWindyState) => ({
          ...prevWindyState,
          [nomeSeriale]: false,
        }));
      }
      return newState;
    });
  };

  const togglePhotoWindy = (nomeSeriale) => {
    setInfoboxStatesPhotoWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: !prevState[nomeSeriale],
    }));
  };

  const toggleStreamingWindy = (nomeSeriale) => {
    setInfoboxStatesStreamingWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: !prevState[nomeSeriale],
    }));
  };

  const toggleFollowTrueWindy = (nomeSeriale, stateButton) => {
    if (infoboxStatesWindy[nomeSeriale]) {
        setInfoboxStatesWindy((prevState) => ({
        ...prevState,
        [nomeSeriale]: true,
        }));
    }
  };

  const toggleFollowTrueWindySimu = (nomeSeriale, stateButton) => {
    if (infoboxStatesWindySimu[nomeSeriale]) {
        setInfoboxStatesWindySimu((prevState) => ({
        ...prevState,
        [nomeSeriale]: true,
        }));
    }
  };

  const toggleFollowFalseWindy = (nomeSeriale) => {
    setInfoboxStatesWindy((prevState) => ({
      ...prevState,
      [nomeSeriale]: false,
    }));
  };
  
  const toggleFollowFalseWindySimu = (nomeSeriale, stateButton) => {
    setInfoboxStatesWindySimu((prevState) => ({
      ...prevState,
      [nomeSeriale]: false,
    }));
  };


      const handleNext = () => {
        if (startIndex > 0) {
            setStartIndex((prevIndex) => prevIndex - 1);
          }
      };
    
      const handlePrev = () => {
        if (startIndex + 1 < FlyObjects.length) {
          setStartIndex((prevIndex) => prevIndex + 1);
        }
      };

    function getBreakpointRulesResponsive(width) {

        // DA GESTIRE logica riguardo le diverse size da adattare tra i vari cellulari

        if(width >= 1 && width <= 374){
            return {
                startIndexCondition: FlyObjects.length - 1,
                flyObjectsCondition: FlyObjects.length >= 2,
            };
        }
        else if(width >= 375 && width <= 519){
            return {
                startIndexCondition: FlyObjects.length - 2,
                flyObjectsCondition: FlyObjects.length >= 3,
            };
        }
        else if(width >= 520 && width <= 664){
            return {
                startIndexCondition: FlyObjects.length - 3,
                flyObjectsCondition: FlyObjects.length >= 4,
            };
        }
        else if(width >= 665 && width <= 809){
            return {
                startIndexCondition: FlyObjects.length - 4,
                flyObjectsCondition: FlyObjects.length >= 5,
            };
        }
        else if(width >= 810 && width <= 954){
            return {
                startIndexCondition: FlyObjects.length - 5,
                flyObjectsCondition: FlyObjects.length >= 6,
            };
        }
        else if(width >= 955 && width <= 1099){
            return {
                startIndexCondition: FlyObjects.length - 6,
                flyObjectsCondition: FlyObjects.length >= 7,
            };
        }
        else if(width >= 1100 && width <= 1244){
            return {
                startIndexCondition: FlyObjects.length - 7,
                flyObjectsCondition: FlyObjects.length >= 8,
            };
        }
        else {
            return {
                startIndexCondition: FlyObjects.length - 7,
                flyObjectsCondition: FlyObjects.length >= 8,
            };
        }



    }

    function getBreakpointRules(width) {

        if (width >= 542 && width <= 935) {
            return {
                startIndexCondition: FlyObjects.length - 1,
                flyObjectsCondition: FlyObjects.length >= 2,
            };
        } else if (width > 935 && width <= 1328) {
            return {
                startIndexCondition: FlyObjects.length - 2,
                flyObjectsCondition: FlyObjects.length >= 3,
            };
        } else if (width > 1329 && width <= 1722) {
            return {
                startIndexCondition: FlyObjects.length - 3,
                flyObjectsCondition: FlyObjects.length >= 4,
            };
        } else if (width > 1722 && width <= 2115) {
            return {
                startIndexCondition: FlyObjects.length - 4,
                flyObjectsCondition: FlyObjects.length >= 5,
            };
        } else if (width > 2115 && width <= 2508) {
            return {
                startIndexCondition: FlyObjects.length - 5,
                flyObjectsCondition: FlyObjects.length >= 6,
            };
        } else {
            return {
                startIndexCondition: FlyObjects.length - 5,
                flyObjectsCondition: FlyObjects.length >= 6,
            };
        }
    }

        // Funzione per aggiornare la variabile mappaWindy
        const aggiornaMappaWindy = (nuovoValore) => {
            setMappaWindy(nuovoValore);
        };

        useEffect(() => {
            const handleResize = () => {
                // Invece di dispatchare un nuovo evento resize, aggiorniamo direttamente ciò che serve
                if (mappa) {
                    mappa.invalidateSize();
                }
                if (mappaWindy) {
                    mappaWindy.invalidateSize();
                }
            };
            

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, [mappa, mappaWindy]);

        const cambiaMappaLeaflet = () => {
            if (mappa) {
                mappa.invalidateSize();
            }
        };

        const cambiaMappaWindy = () => {
            if (mappaWindy) {
                mappaWindy.invalidateSize();
            }
        };

        const cambiaButton = (sn, nuovoStato) => {
/*
            console.log("LOG --->   sn : ", sn.sn);

            console.log("LOG --->   nuovoStato : ", nuovoStato);
*/
            // Aggiorna lo stato dei bottoni in base all'ID o ad un identificativo unico (sn)
            setButtonStates((prevStates) => ({
            ...prevStates,
            [sn.sn]: nuovoStato,
            }));

        };


        useEffect(() => {
            // Aggiungi questa riga per stampare l'array buttonStates
            //console.log("LOG --->   Stato attuale dei bottoni:", buttonStates);
            setButtonStates(buttonStates)
        }, [buttonStates]);

        
          const setFlyToGoogle3D = (lat, lng, altitude, heading) => {
           //console.log("MAPPA 3D : setFlyToGoogle3D");
            const mappaEarth = document.querySelector('gmp-map-3d');
            if(mappaEarth){
                // cambia la visuale della mappa 3D
                //console.log("cambia la visuale della mappa 3D");
                mappaEarth.center = { lat, lng, altitude };
                //mappaEarth.range = 400;
                //mappaEarth.tilt = 70;
                mappaEarth.heading = heading3D;
            }
            setHeading(heading);
          }

          const setFlyToGoogle3DFollow = (lat, lng, altitude, heading) => {
           //console.log("MAPPA 3D : setFlyToGoogle3DFollow");
            const mappaEarth = document.querySelector('gmp-map-3d');
            if(mappaEarth){
                // cambia la visuale della mappa 3D
                //console.log("cambia la visuale della mappa 3D");
                mappaEarth.center = { lat, lng, altitude };
                mappaEarth.range = 1000;
                mappaEarth.tilt = 70;
                mappaEarth.heading = 0;
            }
          }

          const setFlyToLeaflet = (lat, lon) => {
           //console.log("MAPPA LEAFLET : setFlyToLeaflet");
            if(mappa){
                mappa.panTo([lat, lon], flyZoomOptions);
            }
          }

        //console.log("è mobile? " + isMob + " ,  schermo di : " + windowWidthInit);

        _logga("user is loggedIn")
        return (<div className="map-wrapper">
            {code ?
                (
                    <>
                    <MapContainer
                        id="mappaLeaflet" 
                        className="leaflet-container mappaGoogle"
                        whenCreated={setMap}
                        center={startPosition}
                        zoom={zoomLevelBase}
                        zoomControl={false}
                        scrollWheelZoom={true}
                        doubleClickZoom={false}
                        inertia={true}
                    >
                
                        <LayerGroup>
                 
                                    <AuthController
                                        apibase={props.htkBackend}
                                        assetsBase={props.htkAssets}
                                        htkBackend = {props.htkBackend}
                                        onLoginToggle={onLoginToggle}
                                        accessMode={props.accessMode}
                                        _fnUserTipo={_userTipo}
                                        setMappaWindyProps={cambiaMappaWindy}
                                        setSerialsAttivi={listaSnsAttivi}
                                        listSns={listSns}
                                        userTipo={userTipo}
                                        onSessioniChange={handleSessioniChange}
                                    >

                                    </AuthController>

                            {
                                window.innerWidth > 1600 && 
                                    <ZoomControl position="bottomleft" />
                            } 
                            
                            <TileLayer
                                url='https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
                                subdomains={['mt1','mt2','mt3']}
                                />


                            {
                                FlyObjects.map((singleDataSn, index) => {
                                    const deviceSN = singleDataSn[0].SN;
                                    //console.log("singleDataSn [FLYOBJECT] : " , singleDataSn[0].SN);
                                    
                                    // Determina quale componente usare in base al tipo di dispositivo
                                    let ComponentToRender;
                                    if (props.streamingDrone.includes(deviceSN)) {
                                        ComponentToRender = FlyObjectDrone;
                                    } else if (props.streamingBarca.includes(deviceSN)) {
                                        ComponentToRender = FlyObjectBarca;
                                    } else {
                                        ComponentToRender = FlyObject;
                                    }

                                    return (
                                        <ComponentToRender 
                                            key={singleDataSn[singleDataSn.length-1].SN} 
                                            isMob={isMob}
                                            SN={deviceSN}
                                            ALIAS={singleDataSn[0].ALIAS}
                                            rilevazioni={singleDataSn}
                                            toggleFollow={toggleFollow}
                                            index={index}
                                            infoboxStates={infoboxStates}
                                            setInfoboxStates={setInfoboxStates}
                                            streamingDrone={props.streamingDrone}
                                            streamingBarca={props.streamingBarca}
                                            onIconTypeChange={handleIconTypeChange}
                                        />
                                    )
                                })
                            }

                            {
                                Array.isArray(sessioniFromChild) && sessioniFromChild.map((sessione, index) => {
                                    if (sessione.latitude !== null && sessione.longitude !== null && sessione.email !== null && sessione.id_utente !== null) {
                                        return (
                                            <UserObject
                                                key={index}
                                                sessione={sessione}
                                            />
                                        );
                                    }
                                    return null; // Ritorna null se la condizione non è soddisfatta
                                })
                            }

                            
                            {
                                !isMob && // per pc con dimensione dello schermo sopra i 919px
                                (
                                <div className="ControlPanelLaterale d-flex flex-column" id="controlPanelNuovo" 
                                onMouseOver={changeClick} 
                                onMouseOut={changeClick2} 
                                onMouseMove={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onMouseUp={(e) => e.stopPropagation()}
                                onClick={(e) => e.stopPropagation()} >
                                    <ControlPanel 
                                        userTipo={userTipo} 
                                        htkBackend={props.htkBackend} 
                                        setSerialsAttivi={listaSnsAttivi} 
                                        listSns={listSns} 
                                        setMainFlyObject={setFlyObject} 
                                        cambiaButton={cambiaButton}
                                        buttonStates={buttonStates}
                                    />
                                </div>
                                )
                            }


                            {
                                isMob && // mobile
                                (
                                <div className="ControlPanelLateraleResponsive d-flex flex-column" id="controlPanelNuovoResponsive">
                                    <ControlPanelResponsive 
                                        userTipo={userTipo} 
                                        htkBackend={props.htkBackend} 
                                        setSerialsAttivi={listaSnsAttivi}
                                        listSns={listSns} 
                                        setMainFlyObject={setFlyObject}
                                    />
                                </div>
                                )
                            }

                            {
                                isMob && !isIOS &&         // sono su un dispositivo mobile NON IOS

                                <div className='FlyInfoPanelContainerResp d-flex flex-center w-100'>
                                    <div className="FlyInfoPanelContainer2Resp">
                                        <div className="menuResp d-flex flex-center">

                                            <div className='d-flex flex-row divCenterResp'>

                                                <div className='buttonContainerResp d-flex flex-center'>
                                                    
                                                    {                               
                                                        !(startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition) && (
                                                        <button className="btn arrowButtonsResp d-flex flex-center" type="submit">
                                                            <div
                                                                onTouchStart={
                                                                    startIndex !== breakpointRulesResponsive.startIndexCondition && breakpointRulesResponsive.flyObjectsCondition
                                                                        ? handlePrev
                                                                        : null
                                                                }
                                                                className={`fas fa-chevron-left arrowIconsResp d-flex flex-center ${
                                                                    startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition
                                                                        ? 'disabled'
                                                                        : ''
                                                                }`}
                                                                alt="Indietro"
                                                            ></div>
                                                        </button>
                                                        )
                                                    }

                                                </div>

                                                <div className="items-containerResp">
                                                    
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapperResp" style={{marginLeft: `${startIndex * 136}px`,transition: 'margin-left 0.3s ease-in-out',}}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                const deviceSN = singleDataSn[0].SN;
                                                                return (<InfoBoxResponsiveNoIos
                                                                            key={singleDataSn[singleDataSn.length-1].SN}
                                                                            SN={deviceSN}
                                                                            ALIAS={singleDataSn[0].ALIAS}
                                                                            toggleFollow={toggleFollow}
                                                                            togglePhoto={togglePhoto}
                                                                            toggleStreaming={toggleStreaming}
                                                                            infoboxStates={infoboxStates}
                                                                            infoboxStatesPhoto={infoboxStatesPhoto}
                                                                            infoboxStatesStreaming={infoboxStatesStreaming}
                                                                            setInfoboxStates={setInfoboxStates}
                                                                            setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                            userTipo={userTipo}
                                                                            htkBackend={props.htkBackend}
                                                                            allData={singleDataSn}
                                                                            urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                            urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                            urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                            urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                            singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                            serialiStreaming={props.serialiStreaming}
                                                                            streamingH265={props.streamingH265}
                                                                            streamingH264={props.streamingH264}
                                                                            streamingDrone={props.streamingDrone}
                                                                            streamingBarca={props.streamingBarca}
                                                                            currentIconType={currentIconTypeStates[deviceSN]}
                                                                        />)
                                                            })
                                                        }
                                                    </div>

                                                </div>

                                                <div className='buttonContainerResp d-flex flex-center'>

                                                        {
                                                            !(startIndex === 0) &&

                                                            <button className="btn arrowButtonsResp d-flex flex-center" type="submit">
                                                                <div
                                                                    onTouchStart={startIndex !== 0 ? handleNext : null}
                                                                    className={`fas fa-chevron-right arrowIconsResp d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                                    alt="Avanti"
                                                                ></div>
                                                            </button>
                                                        }
                                                    
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                    
                                    
                            }


                            {
                                isMob && isIOS &&         // sono su un dispositivo mobile IOS

                                <div className='FlyInfoPanelContainerResp d-flex flex-center w-100'>
                                    <div className="FlyInfoPanelContainer2Resp">
                                        <div className="menuResp d-flex flex-center">

                                            <div className='d-flex flex-row divCenterResp'>

                                                <div className='buttonContainerResp d-flex flex-center'>
                                                    
                                                    {                               
                                                        !(startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition) && (
                                                        <button className="btn arrowButtonsResp d-flex flex-center" type="submit">
                                                            <div
                                                                onTouchStart={
                                                                    startIndex !== breakpointRulesResponsive.startIndexCondition && breakpointRulesResponsive.flyObjectsCondition
                                                                        ? handlePrev
                                                                        : null
                                                                }
                                                                className={`fas fa-chevron-left arrowIconsResp d-flex flex-center ${
                                                                    startIndex === breakpointRulesResponsive.startIndexCondition || !breakpointRulesResponsive.flyObjectsCondition
                                                                        ? 'disabled'
                                                                        : ''
                                                                }`}
                                                                alt="Indietro"
                                                            ></div>
                                                        </button>
                                                        )
                                                    }

                                                </div>

                                                <div className="items-containerResp">
                                                    
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapperResp" style={{marginLeft: `${startIndex * 136}px`,transition: 'margin-left 0.3s ease-in-out',}}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                const deviceSN = singleDataSn[0].SN;
                                                                return (<InfoBoxResponsiveIos
                                                                            key={singleDataSn[singleDataSn.length-1].SN}
                                                                            SN={deviceSN}
                                                                            ALIAS={singleDataSn[0].ALIAS}
                                                                            toggleFollow={toggleFollow}
                                                                            togglePhoto={togglePhoto}
                                                                            toggleStreaming={toggleStreaming}
                                                                            infoboxStates={infoboxStates}
                                                                            infoboxStatesPhoto={infoboxStatesPhoto}
                                                                            infoboxStatesStreaming={infoboxStatesStreaming}
                                                                            setInfoboxStates={setInfoboxStates}
                                                                            setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                            userTipo={userTipo}
                                                                            htkBackend={props.htkBackend}
                                                                            allData={singleDataSn}
                                                                            urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                            urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                            urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                            urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                            singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                            serialiStreaming={props.serialiStreaming}
                                                                            streamingH265={props.streamingH265}
                                                                            streamingH264={props.streamingH264}
                                                                            streamingDrone={props.streamingDrone}
                                                                            streamingBarca={props.streamingBarca}
                                                                            currentIconType={currentIconTypeStates[deviceSN]}
                                                                        />)
                                                            })
                                                        }
                                                    </div>

                                                </div>

                                                <div className='buttonContainerResp d-flex flex-center'>

                                                        {
                                                            !(startIndex === 0) &&

                                                            <button className="btn arrowButtonsResp d-flex flex-center" type="submit">
                                                                <div
                                                                    onTouchStart={startIndex !== 0 ? handleNext : null}
                                                                    className={`fas fa-chevron-right arrowIconsResp d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                                    alt="Avanti"
                                                                ></div>
                                                            </button>
                                                        }
                                                    
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                                    
                                    
                            }


                            { 
                                !isMob &&
                                
                                <div className='FlyInfoPanelContainer d-flex flex-center w-100'>

                                    <div className="FlyInfoPanelContainer2">

                                        <div className="menu">

                                            <div className='buttonContainer d-flex flex-center'>
                                                
                                                
                                                {                               
                                                    !(startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition) && (
                                                    <button className="btn arrowButtons d-flex flex-center" type="submit">
                                                        <div
                                                            onClick={
                                                                startIndex !== breakpointRules.startIndexCondition && breakpointRules.flyObjectsCondition
                                                                    ? handlePrev
                                                                    : null
                                                            }
                                                            className={`fas fa-chevron-left arrowIcons d-flex flex-center ${
                                                                startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition
                                                                    ? 'disabled'
                                                                    : ''
                                                            }`}
                                                            alt="Indietro"
                                                        ></div>
                                                    </button>
                                                    )
                                                }

                                            </div>

                                            <div className="items-container">
                                                
                                                    <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapper" style={{ transform: `translateX(+${startIndex * 350}px)` }}>
                                                        {
                                                            FlyObjects.map((singleDataSn, index) => {
                                                                // console.log("singleDataSn [INFOBOX] : " , singleDataSn[0].SN);
                                                                //console.log("seriali passati all'Infobox: " , singleDataSn[0].SN);
                                                                const deviceSN = singleDataSn[0].SN;
                                                                const uniqueKey = `${deviceSN}_${index}`; // Generiamo una chiave veramente unica
                                                                return snsLive.some(item => item.sn === deviceSN) ? ( // Renderizziamo solo se il dispositivo è attivo
                                                                    <InfoBox
                                                                        key={uniqueKey}
                                                                        SN={deviceSN}
                                                                        ALIAS={singleDataSn[0].ALIAS}
                                                                        toggleFollow={toggleFollow}
                                                                        toggleFollowFalse={toggleFollowFalse}
                                                                        togglePolygonFalse={togglePolygonFalse}
                                                                        togglePhoto={togglePhoto}
                                                                        toggleStreaming={toggleStreaming}
                                                                        infoboxStates={infoboxStates}
                                                                        infoboxStatesPhoto={infoboxStatesPhoto}
                                                                        infoboxStatesPolygon={infoboxStatesPolygon}
                                                                        infoboxStatesStreaming={infoboxStatesStreaming}
                                                                        setInfoboxStatesPhoto={setInfoboxStatesPhoto}
                                                                        setInfoboxStatesPolygon={setInfoboxStatesPolygon}
                                                                        setInfoboxStates={setInfoboxStates}
                                                                        setInfoboxStatesStreaming={setInfoboxStatesStreaming}
                                                                        index={index}
                                                                        userTipo={userTipo}
                                                                        htkBackend={props.htkBackend}
                                                                        allData={singleDataSn}
                                                                        urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                                        urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                                        urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                                        urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                                        singleSnData={singleDataSn[singleDataSn.length-1]}
                                                                        serialiStreaming={props.serialiStreaming}
                                                                        streamingH265={props.streamingH265}
                                                                        streamingH264={props.streamingH264}
                                                                        streamingDrone={props.streamingDrone}
                                                                        streamingBarca={props.streamingBarca}
                                                                        setFlyToLeaflet={setFlyToLeaflet}
                                                                        currentIconType={currentIconTypeStates[singleDataSn[0].SN]}
                                                                    />
                                                                ) : null;
                                                            })
                                                        }
                                                    </div>

                                            </div>

                                            <div className='buttonContainer d-flex flex-center'>

                                               

                                                {
                                                    !(startIndex === 0) &&

                                                    <button className="btn arrowButtons d-flex flex-center" type="submit">
                                                        <div
                                                            onClick={startIndex !== 0 ? handleNext : null}
                                                            className={`fas fa-chevron-right arrowIcons d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                                            alt="Avanti"
                                                        ></div>
                                                    </button>
                                                }
                                            
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            }

                        </LayerGroup>

                </MapContainer>

                {/* Nodo Target per il Portale degli Stream della Barca */}
                <div id="boat-stream-portal-root"></div>

                </>
                )
                :
                (<div className="container d-flex flex-column aligns-items-center justify-content-center p-2">
                    <h4>QLive Application</h4>
                    <div className="d-flex w-25 flex-column justify-content-center">

                        <input className="p-2" placeholder="Insert code" onChange={(e) => {setDaCode(e.target.value)}} />
                        <button className="btn m-3" onClick={_checkAccess}>Access with {dataCode} code</button>
                    </div>
                </div>)

            }

 {
    
    !isMob &&
    <div id="mappaGoogle3D">
        <Map3DComponent
          htkApiMaps={props.htkApiMaps}
          infoboxStates={infoboxStatesWindy}
          infoboxStatesSimu={infoboxStatesWindySimu}
        />
    </div>
    
 }

    {
        !isMob &&
        <div className="spinner-wrapper" id="spinnerWrapper">
            <div className="loading-spinner"></div>
            <span className="spinner-text">3D</span>
        </div>
    }

 {
    !isMob &&
            <AuthControllerWindy
                apibase={props.htkBackend}
                assetsBase={props.htkAssets}
                htkBackend = {props.htkBackend}
                onLoginToggle={onLoginToggle}
                htkBackendEmail={props.htkBackendEmail}
                accessMode={props.accessMode}
                _fnUserTipo={_userTipo}
                mappaLeaflet={mappa}
                setMappaLeafletProps={cambiaMappaLeaflet}
            >

            </AuthControllerWindy>
}
     
        {
            !isMob &&
            <div className="ControlPanelWindy d-flex flex-column" id="controlPanelNuovo">
                <ControlPanelWindy 
                    userTipo={userTipo} 
                    htkBackend={props.htkBackend} 
                    setSerialsAttivi={listaSnsAttivi} 
                    serials={snsJson.serials} 
                    listSns={listSns} 
                    setMainFlyObject={setFlyObject} 
                    cambiaButton={cambiaButton}
                    buttonStates={buttonStates}
                />
            </div>
        
        }


        {
            !isMob &&

            <div className='FlyInfoPanelContainerWindy d-flex flex-center w-100'>

                <div className="FlyInfoPanelContainer2Windy">

                    <div className="menu">

                        <div className='buttonContainer d-flex flex-center'>
                            
                            
                            {                               
                                !(startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition) && (
                                <button className="btn arrowButtons d-flex flex-center" type="submit">
                                    <div
                                        onClick={
                                            startIndex !== breakpointRules.startIndexCondition && breakpointRules.flyObjectsCondition
                                                ? handlePrev
                                                : null
                                        }
                                        className={`fas fa-chevron-left arrowIcons d-flex flex-center ${
                                            startIndex === breakpointRules.startIndexCondition || !breakpointRules.flyObjectsCondition
                                                ? 'disabled'
                                                : ''
                                        }`}
                                        alt="Indietro"
                                    ></div>
                                </button>
                                )
                            }

                        </div>

                        <div className="items-container">
                            
                                <div className="w-100 align-items-end ms-5 d-flex flex-row-reverse items-wrapper" style={{ transform: `translateX(+${startIndex * 350}px)` }}>
                                    {
                                        FlyObjects.map((singleDataSn, index) => {
                                            const deviceSN = singleDataSn[0].SN;
                                            return (<InfoBoxWindy
                                                        key={singleDataSn[singleDataSn.length-1].SN}
                                                        SN={deviceSN}
                                                        ALIAS={singleDataSn[0].ALIAS}
                                                        toggleFollow={toggleFollowWindy}
                                                        toggleFollowSimu={toggleFollowWindySimu}
                                                        toggleFollowFalse={toggleFollowFalseWindy}
                                                        toggleFollowFalseSimu={toggleFollowFalseWindySimu}
                                                        toggleFollowTrue={toggleFollowTrueWindy}
                                                        toggleFollowTrueSimu={toggleFollowTrueWindySimu}
                                                        togglePhoto={togglePhotoWindy}
                                                        toggleStreaming={toggleStreamingWindy}
                                                        infoboxStates={infoboxStatesWindy}
                                                        infoboxStatesSimu={infoboxStatesWindySimu}
                                                        infoboxStatesPhoto={infoboxStatesPhotoWindy}
                                                        infoboxStatesStreaming={infoboxStatesStreamingWindy}
                                                        setInfoboxStatesPhoto={setInfoboxStatesPhotoWindy}
                                                        setInfoboxStates={setInfoboxStatesWindy}
                                                        setInfoboxStatesSimu={setInfoboxStatesWindySimu}
                                                        setInfoboxStatesStreaming={setInfoboxStatesStreamingWindy}
                                                        setFlyToGoogle3D={setFlyToGoogle3D}
                                                        setFlyToGoogle3DFollow={setFlyToGoogle3DFollow}
                                                        index={index}
                                                        userTipo={userTipo}
                                                        htkBackend={props.htkBackend}
                                                        htkCDN={props.htkCDN}
                                                        allData={singleDataSn}
                                                        urlVideoStreamingH265={props.htkVideoStreamingH265}
                                                        urlVideoStreamingH264={props.htkVideoStreamingH264}
                                                        urlVideoStreamingDrone={props.htkVideoStreamingDrone}
                                                        urlVideoStreamingBarca={props.htkVideoStreamingBarca}
                                                        singleSnData={singleDataSn[singleDataSn.length-1]}
                                                        allSnData={singleDataSn}
                                                        serialiStreaming={props.serialiStreaming}
                                                        streamingH265={props.streamingH265}
                                                        streamingH264={props.streamingH264}
                                                        streamingDrone={props.streamingDrone}
                                                        streamingBarca={props.streamingBarca}
                                                        rilevazioni={singleDataSn}
                                                        currentIconType={currentIconTypeStates[deviceSN]}
                                                    />)
                                        })
                                    }
                                </div>

                        </div>

                        <div className='buttonContainer d-flex flex-center'>

                            

                            {
                                !(startIndex === 0) &&

                                <button className="btn arrowButtons d-flex flex-center" type="submit">
                                    <div
                                        onClick={startIndex !== 0 ? handleNext : null}
                                        className={`fas fa-chevron-right arrowIcons d-flex flex-center ${startIndex === 0 ? 'disabled' : ''}`}
                                        alt="Avanti"
                                    ></div>
                                </button>
                            }
                        
                        </div>

                    </div>

                </div>

            </div>


                        }


        </div>);
}
export default App;
